
    <div class="scroll-content" #scrollContent>
      <ng-content></ng-content>
    </div>
    <div class="scroll-bottom" *ngIf="show_bottom_scroll" inlineSVG="sot/sot-icon.svg#sot-down_arrows" [setSVGAttributes]="{class: 'arrows'}"></div>
    